
document.addEventListener('DOMContentLoaded', function() {
  // Progress bar
  var prog = document.querySelector('.kprog');
  if (prog) window.addEventListener('scroll', function() {
    var h = document.documentElement;
    prog.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) + '%';
  });
  // Nav shrink
  var head = document.querySelector('.khead');
  if (head) window.addEventListener('scroll', function() {
    head.classList.toggle('shrink', window.scrollY > 60);
  });
  // Cart
  var cov = document.querySelector('.cov');
  var cd = document.querySelector('.cdrawer');
  window.openCart = function() { cov && cov.classList.add('on'); cd && cd.classList.add('on'); document.body.style.overflow = 'hidden'; };
  window.closeCart = function() { cov && cov.classList.remove('on'); cd && cd.classList.remove('on'); document.body.style.overflow = ''; };
  cov && cov.addEventListener('click', closeCart);
  var ccls = document.querySelector('.ccls');
  ccls && ccls.addEventListener('click', closeCart);
  // ATC
  document.querySelectorAll('[data-atc]').forEach(function(btn) {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      var vid = this.dataset.variantId;
      if (!vid) return;
      var qty = 1;
      var qtyInput = document.getElementById('pdp-qty-input');
      if (qtyInput && this.id === 'pdp-atc') {
        qty = parseInt(qtyInput.value, 10) || 1;
      }
      var payload = {id: vid, quantity: qty};
      if (this.id === 'pdp-atc') {
        var subscribeChecked = document.querySelector('input[name="purchase_option"][value="subscribe"]');
        if (subscribeChecked && subscribeChecked.checked) {
          var activePill = document.querySelector('#pdp-freq-row .pdp-freq-pill.active');
          var singleInput = document.getElementById('pdp-selling-plan-single');
          var planId = activePill ? activePill.dataset.planId : (singleInput ? singleInput.value : (this.dataset.firstSellingPlanId || null));
          if (planId) payload.selling_plan = planId;
        }
      }
      var orig = this.textContent; this.textContent = '...'; this.disabled = true;
      try {
        var r = await fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)});
        if (r.ok) { await updateCart(); bumpBadge(); openCart(); }
      } catch(e) { console.error(e); }
      this.textContent = orig; this.disabled = false;
    });
  });
  // Update cart
  async function updateCart() {
    try {
      var r = await fetch('/cart.js');
      var cart = await r.json();
      var badge = document.querySelector('.cbadge');
      if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
      var countEl = document.getElementById('cart-item-count');
      if (countEl) countEl.textContent = cart.item_count > 0 ? cart.item_count + ' Artikel' : '';
      var items = document.querySelector('.citems');
      var empty = document.querySelector('.cempty');
      var ft = document.querySelector('.cft');
      if (!items) return;
      items.querySelectorAll('.citem').forEach(function(e){e.remove();});
      if (cart.item_count === 0) { empty && (empty.style.display='block'); ft && (ft.style.display='none'); return; }
      empty && (empty.style.display='none'); ft && (ft.style.display='block');
      cart.items.forEach(function(item) {
        var d = document.createElement('div'); d.className = 'citem';
        var price = (item.final_price/100).toFixed(2).replace('.',',');
        var linePrice = (item.final_line_price/100).toFixed(2).replace('.',',');
        d.innerHTML =
          '<div class="cimg">' + (item.image ? '<img src="'+item.image+'" alt="">' : '<span>神</span>') + '</div>' +
          '<div style="flex:1;min-width:0;">' +
            '<div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:3px;">' +
              '<a href="/products/'+item.handle+'" class="cname" style="flex:1;padding-right:8px;text-decoration:none;color:inherit;cursor:pointer;" onclick="closeCart()">'+item.product_title+'</a>' +
              '<button data-key="'+item.key+'" class="cart-remove-btn" style="background:none;border:none;color:var(--m);font-size:16px;cursor:pointer;padding:0 0 0 8px;line-height:1;flex-shrink:0;">×</button>' +
            '</div>' +
            '<div class="cvar">'+(item.variant_title && item.variant_title!=='Default Title' && item.variant_title!=='NULL' && item.variant_title!=='null' ? item.variant_title : 'Premium Body Wash · 250ml')+'</div>' +
            '<div style="display:flex;justify-content:space-between;align-items:center;margin-top:10px;">' +
              '<div class="cart-qty-wrap">' +
                '<button class="cart-qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity-1)+'">−</button>' +
                '<span class="cart-qty-num">'+item.quantity+'</span>' +
                '<button class="cart-qty-btn" data-key="'+item.key+'" data-qty="'+(item.quantity+1)+'">+</button>' +
              '</div>' +
              '<div class="cprice">€'+linePrice+'</div>' +
            '</div>' +
          '</div>';
        items.appendChild(d);
      });

      // Versandleiste (Deutschland)
      var shipBar = document.getElementById('cship-bar');
      if (shipBar) {
        var remaining = 4900 - cart.total_price;
        if (remaining <= 0) {
          shipBar.innerHTML = '<span style="color:var(--gr);">✓ Kostenloser Versand in Deutschland freigeschaltet</span>';
        } else {
          var pct = Math.min(100, Math.round((cart.total_price / 4900) * 100));
          shipBar.innerHTML =
            '<div style="display:flex;justify-content:space-between;margin-bottom:6px;">' +
              '<span>Noch <strong style="color:var(--w);">€' + (remaining/100).toFixed(0) + '</strong> bis zum Gratis-Versand (DE)</span>' +
              '<span>' + pct + '%</span>' +
            '</div>' +
            '<div style="height:3px;background:var(--ln);border-radius:3px;overflow:hidden;margin-bottom:14px;">' +
              '<div style="height:100%;width:'+pct+'%;background:linear-gradient(90deg,var(--g),var(--g2));border-radius:3px;transition:width .6s ease;"></div>' +
            '</div>';
        }
      }
      // Versandkosten + Total (Deutschland)
      var freeShipping = cart.total_price >= 4900;
      var shippingCost = freeShipping ? 0 : 499;
      var totalWithShipping = cart.total_price + shippingCost;
      var shipCostEl = document.getElementById('cart-shipping');
      if (shipCostEl) shipCostEl.textContent = freeShipping ? 'Kostenlos' : '€4,99';
      var totalDisplay = document.getElementById('cart-total-display');
      if (totalDisplay) totalDisplay.textContent = '€' + (totalWithShipping/100).toFixed(2).replace('.',',');
      // Subtotal
      var sub = document.querySelector('#cart-subtotal');
      if (sub) sub.textContent = '€' + (cart.total_price/100).toFixed(2).replace('.',',');
    } catch(e) { console.error(e); }
  }
  function bumpBadge() { var b = document.querySelector('.cbadge'); if (b) { b.classList.add('pop'); setTimeout(function(){b.classList.remove('pop');}, 400); } }

  // Menge ändern via event delegation
  async function changeQty(key, qty) {
    try {
      var r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: Math.max(0, qty)})
      });
      if (r.ok) await updateCart();
    } catch(e) { console.error(e); }
  }

  // Cart item entfernen
  async function removeFromCart(key) {
    try {
      var r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: 0})
      });
      if (r.ok) {
        await updateCart();
        var cartR = await fetch('/cart.js');
        var cart = await cartR.json();
        var badge = document.querySelector('.cbadge');
        var badgeMob = document.querySelector('.mob-cart-num');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        if (badgeMob) badgeMob.textContent = cart.item_count;
      }
    } catch(e) { console.error('removeFromCart error:', e); }
  }

  updateCart();

  // Cart event delegation — remove + qty
  document.addEventListener('click', function(e) {
    var removeBtn = e.target.closest('.cart-remove-btn');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var key = removeBtn.dataset.key;
      if (key) removeFromCart(key);
      return;
    }
    var qtyBtn = e.target.closest('.cart-qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();
      var key = qtyBtn.dataset.key;
      var qty = parseInt(qtyBtn.dataset.qty);
      if (key && !isNaN(qty)) changeQty(key, qty);
      return;
    }
  });
  // FAQ
  document.querySelectorAll('.fq').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = this.closest('.fitem');
      var was = item.classList.contains('open');
      document.querySelectorAll('.fitem').forEach(function(i){i.classList.remove('open');});
      if (!was) item.classList.add('open');
    });
  });
  document.querySelectorAll('.fcat').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.fcat').forEach(function(b){b.classList.remove('on');});
      this.classList.add('on');
      var cat = this.dataset.cat;
      document.querySelectorAll('.fitem').forEach(function(item) {
        item.classList.remove('open');
        item.style.display = (cat==='all' || item.dataset.cat===cat) ? 'block' : 'none';
      });
    });
  });
  // Variants
  document.querySelectorAll('.pvar').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var form = this.closest('form') || document.querySelector('.pdp-lay');
      form && form.querySelectorAll('.pvar').forEach(function(b){b.classList.remove('active');});
      this.classList.add('active');
      var atc = form && form.querySelector('.pdp-atc');
      if (atc && this.dataset.variantId) atc.dataset.variantId = this.dataset.variantId;
    });
  });
  // Reveal
  var obs = new IntersectionObserver(function(es) {
    es.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('vis'); obs.unobserve(e.target); } });
  }, {threshold: 0.1});
  document.querySelectorAll('.rv,.rvs').forEach(function(el){obs.observe(el);});
  // Email
  var ef = document.querySelector('.eml-f');
  if (ef) ef.addEventListener('submit', function(e) {
    e.preventDefault();
    var i = this.querySelector('.eml-i');
    if (i && i.value) { i.value=''; i.placeholder='✓ Willkommen bei KAMUI'; i.style.borderColor='var(--g)'; }
  });
});

function toggleFaq(item) {
  var was = item.classList.contains('open');
  document.querySelectorAll('.fitem').forEach(function(i) {
    i.classList.remove('open');
  });
  if (!was) {
    item.classList.add('open');
  }
}
